<template>
  <b-container fluid class="animated fadeIn">
    <div class="d-flex align-items-center">
      <b-col>
        <h1 class="app-title mt-4">
          Alterar Modelo
        </h1>
      </b-col>
    </div>
    <b-card>
      <b-row>
        <b-col xs="12" sm="12" md="8" lg="8" xl="8">
          <b-form-group
            label="Descrição: *"
            label-for="descricao"
            class="text-label"
          >
            <b-form-input
              name="descricao"
              v-model="minuta.descricao"
              type="text"
              maxlength="150"
              v-validate="{ required: true }"
            />
          </b-form-group>
        </b-col>
        <b-col xs="12" sm="12" md="4" lg="4" xl="4">
          <b-form-group
            label="Movimento: *"
            label-for="movimento"
            class="text-label"
          >
            <multiselect
              name="movimento"
              :show-labels="false"
              :options="listaMovimento.options"
              v-model="minuta.movimento"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="true"
              :preserve-search="false"
              placeholder="Selecione"
              track-by="value"
              label="text"
            >
            </multiselect>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xs="12" sm="12" md="4" lg="4" xl="4">
          <b-form-group
            label="Tipo Tramitação: *"
            label-for="tipoTramitacao"
            class="text-label"
          >
            <multiselect
              name="tipoTramitacao"
              v-model="minuta.tipoTramitacao"
              :show-labels="false"
              :options="listaTipoTramitacao.options"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="true"
              :preserve-search="false"
              placeholder="Selecione"
              track-by="value"
              label="text"
            >
            </multiselect>
          </b-form-group>
        </b-col>
        <b-col xs="12" sm="12" md="4" lg="4" xl="4">
          <b-form-group
            label="Tipo de Documento: *"
            label-for="tipoDocumento"
            class="text-label"
          >
            <multiselect
              name="tipoDocumento"
              v-model="minuta.tipoDocumentoValor"
              :show-labels="false"
              :options="listaTipoDocumento.options"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="true"
              :preserve-search="false"
              placeholder="Selecione"
              track-by="value"
              label="text"
            >
            </multiselect>
          </b-form-group>
        </b-col>
        <b-col xs="12" sm="12" md="2" lg="2" xl="2">
          <b-form-group
            label="Situação: *"
            label-for="nome"
            class="text-label"
          >
            <b-form-radio-group
              id="radio-group-1"
              v-model="minuta.indAtivo"
              :options="situacao.options"
            >
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>


      <b-row>
        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
          <vue-editor id="editor" v-model="minuta.textoModelo" ></vue-editor>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col xs="12" sm="12" md="4" lg="4" xl="4">
          <b-button
            variant="primary"
            @click.prevent="salvar"
            :disabled="inSave"
          >
            <i class="fa fa-save"></i> Salvar
          </b-button>
          <b-button variant="primary" class="ml-2" @click="voltar">
            <i class="fa fa-reply"></i> Voltar
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>

import axios from "axios";
import formatarMixins from "../../../mixins/formatarMixins";
import { VueEditor } from "vue2-editor";


const TipoDocumentoEnum = Object.freeze({
  APELACAO: "Apelação",
  CONTESTACAO: "Contestação",
  EMBARGOS: "Embargos de Declaração",
  PETICAO: "Petição Outras"
})

export default {
  name: "ManterMinutaEditar",
  mixins: [formatarMixins],
  components: {
    VueEditor,
  },
  data() {
    return {
      minuta: {
        descricao: null,
        movimento: null,
        tipoTramitacao: null,
        tipoDocumentoValor: null,
        textoModelo: null,
        indAtivo: true,
      },
      listaMovimento:{
        options:[
          {value: null, text: "Selecione" },
        ]
      },
      listaTipoTramitacao:{
        selected: null,
        options:[
          {value: null, text: "Selecione" },
        ]
      },
      listaTipoDocumento:{
        selected: null,
        options:[
          {value: null, text: "Selecione" },
          {value: 'APELACAO', text: "Apelação" },
          {value: 'CONTESTACAO', text: "Contestação" },
          {value: 'EMBARGOS', text: "Embargos de Declaração" },
          {value: 'PETICAO', text: "Petição Outras" },
        ]
      },
      situacao: {
        selected: "todos",
        options: [
          { text: "Ativo", value: true },
          { text: "Inativo", value: false },
        ],
      },
      msgErroFormulario: null,
      inSave: false,
    };
  },


  methods: {
    salvar(evt) {
      evt.preventDefault();
      this.inSave = true;
      this.msgErroFormulario = null;

      this.$validator.validateAll().then(async (result) => {
        if (!result || !this.minuta.tipoDocumentoValor.value || !this.minuta.movimento.value || !this.minuta.tipoTramitacao.value) {
          this.msgErroFormulario = "Favor preencher os campos obrigatórios (*)";
          this.inSave = false;
          return;
        }

        const peticao  = {
          codMovimento: this.minuta.movimento.value,
          codTipoTramitacao: this.minuta.tipoTramitacao.value,
          tipoDocumento: this.minuta.tipoDocumentoValor.value,
          ...this.minuta
        }

        const token = JSON.parse(this.$store.getters.getUser).access_token;
        const urlApi = process.env.VUE_APP_ROOT_API;
        const id = this.minuta.id


        await axios
          .put(`${urlApi}/v1/modelopeticao/${id}`, peticao, {
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
          })
          .then((response) => {
            if (response.data) {
              this.msgErroFormulario = `${response.data.message}`;
              return;
            }
            
            this.$router.push({ path: "/minuta" });

            this.$store.commit("setMessages", {
              message: "Sucesso",
              variant: "success",
              errors: ["Operação realizada com sucesso!!!"],
            });

          })
          .catch((error) => {
            this.exibirErro(error);
          })
          .finally(() => {
            this.inSave = false;
          });
      });
      this.inSave = false;
    },

    voltar() {
      this.$router.push({ path: "/minuta" });
    },

    async listarMovimentos() {
      const urlApi = process.env.VUE_APP_ROOT_API;
      const token = JSON.parse(this.$store.getters.getUser).access_token;

      axios.get(`${urlApi}/v1/modelopeticao/movimento?movimentolocal=true&situacao=A`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        }
      }).then((response) => {
        response.data.forEach(el => {
          this.listaMovimento.options.push({value: el.codigo, text: el.descricao})
        });
      });
    },
    async listarTipoTramitacao() {
      const urlApi = process.env.VUE_APP_ROOT_API;
      const token = JSON.parse(this.$store.getters.getUser).access_token;

      axios.get(`${urlApi}/v1/modelopeticao/tipotramitacao`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        }
      }).then((response) => {
        response.data.forEach(el => {
          this.listaTipoTramitacao.options.push({
            value: el.id,
            text: `${el.sigla} - ${el.nome}`
          })
        });
      });
    },

  },
  mounted() {
    this.listarMovimentos()
    this.listarTipoTramitacao()

    this.$store.commit("setMessages", {});

    const modelMinuta = this.$store.getters.getModeloMinuta;
    this.minuta = {
      id: modelMinuta.id,
      descricao: modelMinuta.descricao,
      indAtivo: modelMinuta.indAtivo,
      textoModelo: modelMinuta.textoModelo,
      tipoDocumentoValor: { value: modelMinuta.tipoDocumento, text: TipoDocumentoEnum[modelMinuta.tipoDocumento] },
      movimento: { value: modelMinuta.codMovimento, text: modelMinuta.descricaoMovimento },
      tipoTramitacao: { value: modelMinuta.codTipoTramitacao, text: modelMinuta.textoTipoTramitacao }
    }
  }
};
</script>

<style scoped>
#editor {
  height: 500px;
}
.ql-editor {
    min-height: 380px !important;
    font-size: 14px;
}
</style>
